import { Fragment } from "react";
import { Form, json, redirect } from "react-router-dom";
import { createCpaTest } from "../../../api/OnboardCpa/fetchTest.js";
import OnboardCpaSteps from "../../ui/steps/OnboardCpaSteps.js";
import { Handler401 } from "../../../api/utils/responseActions.js";
import MobileNavBar from "../../navegation/MobileNavBar.js";

function CpaTest() {
  return (
    <Fragment>
      <main className="mainOneTwo">
        <div className="content">
          <OnboardCpaSteps value={1} />
          <div>
            <h1>Prove your expertise, once and done.</h1>
            <br />
            <hr />
            <br />

            <p>
              To keep our network top-tier, every pro completes a short
              knowledge check.
            </p>
            <div id="terms">
              <ul>
                <li>Just 5 multiple-choice questions </li>
                <li>30 minutes to answer</li>
                <li>
                  Pass it once, and you’re cleared for every future season It’s
                  simple — and it shows clients you’re the real deal.”
                </li>
              </ul>
            </div>
          </div>

          <Form method="post">
            <button className="btn btnBox btnAfter" data-icon="arrow_forward">
              <b>Start the test</b>
            </button>
          </Form>
        </div>
        <MobileNavBar />
      </main>
    </Fragment>
  );
}

export default CpaTest;

export async function action({ request }) {
  // time when client initiate the test creation in milliseconds
  const startTest = new Date();
  const startTestMilliseconds = startTest.getTime();
  const data = { startTestMilliseconds: startTestMilliseconds };

  let endpoint = "utils/cpa-test";
  const response = await createCpaTest(request, endpoint, data);

  if (response.status === 401) {
    return Handler401();
  }

  const restData = await response.json();

  if (!response.ok) {
    throw json({ message: "Could not create user account." }, { status: 500 });
  }

  const url = "" + restData.testId;

  return redirect(url);
}
